import React from "react"
import { notification } from "antd"
import api from "src/api"

export function useManageItems(getItems) {

  async function onSave(values) {
    try {
      await api.post('delivery-zones', values, {useV2Api: true})

      notification.success({message: "Изменения отправлены"})
      getItems()
    } catch (error) {
      console.log("Ошибка отправки", error)
      notification.error({ message: "Ошибка отправки" })
      throw error
    }
  }

  async function onSendMass(values, pointId) {
    try {
      if (pointId) {
        await api.post(`delivery-zones/mass-edit-time/${pointId}`, values, {useV2Api: true})
      } else {
        await api.post(`delivery-zones/all-edit-time`, values, {useV2Api: true})
      }


      notification.success({message: "Время изменено"})
      getItems()
    } catch (error) {
      console.log("Ошибка изменения", error)
      notification.error({ message: "Ошибка изменения" })
      throw error
    }
  }

  async function onDownloadMap() {
    try {
      const file = await api.get("delivery-zones/geojson", {
        useV2Api: true,
        responseType: "blob",
      })

      console.log("file", file)

      const blob = new Blob([file], {
        type: "application/geo+json;charset=utf-8",
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.download = `delivery-zones-${new Date().toISOString().slice(0, 10)}.geojson`
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)

      notification.success({ message: "Карта успешно загружена" })
    } catch (error) {
      console.log("Ошибка загрузки карты", error)
      notification.error({ message: "Ошибка загрузки карты" })
      throw error
    }
  }


  return { onSave, onSendMass, onDownloadMap }
}
